type Props = {
  fileIds: number[]
  onFileIdsChange: (ids: number[]) => void
}

export function VerifyDialogDocumentSection({ fileIds, onFileIdsChange }: Props) {
  return (
    <div className="space-y-2">
      <label className="text-xs font-medium text-slate-600">
        ID plików potwierdzających (z plików umowy, po przecinku)
      </label>
      <input
        type="text"
        value={fileIds.join(', ')}
        onChange={e => {
          const parsed = e.target.value
            .split(',')
            .map(s => parseInt(s.trim(), 10))
            .filter(n => !isNaN(n) && n > 0)
          onFileIdsChange(parsed)
        }}
        placeholder="np. 501, 502"
        className="w-full rounded border border-slate-300 p-2 text-sm focus:border-emerald-500 focus:outline-none"
      />
      <p className="text-xs text-slate-500">
        Pliki musi wgrać osobno (zakładka Pliki); tu podajesz ich identyfikatory.
      </p>
    </div>
  )
}
